import React, { createContext, useContext, useState } from 'react';

const StatusToastContext = createContext();

export const StatusToastProvider = ({ children }) => {
  const [status, setStatus] = useState('idle'); // 'idle' | 'uploading' | 'updated'
  const [message, setMessage] = useState('');
  const [showToast, setShowToast] = useState(false);

  const setStatusToast = (type, msg) => {
    setStatus(type);
    setMessage(msg);
    setShowToast(true);

    if (type === 'updated') {
      setTimeout(() => {
        setShowToast(false);
        setStatus('idle');
        setMessage('');
      }, 10000);
    }
  };

  return (
    <StatusToastContext.Provider value={{ status, message, showToast, setStatusToast }}>
      {children}
    </StatusToastContext.Provider>
  );
};

export const useStatusToast = () => useContext(StatusToastContext);